var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"grid-container",attrs:{"id":"content"}},[_c('p',[_vm._v("Loading the Prismic's Preview...")])])
}]

export { render, staticRenderFns }